import React from 'react';

import Grid from 'shared-components/components/Grid';
import GridItem from 'shared-components/components/GridItem';

import './style.scss';

export default function SearchBlock({
  label,
  button,
  more = null, 
  onClickAction,
  onKeyPressAction,
  shorterOnMobile = false,
  smaller = false,
  className,
  column,
  isLocality = false,
  icon = null,
  isPlaceholder = false,
  notClickable = false,

  ariaLabel = null,
  ariaDescription = null,
  ariaHaspopup = null,
  ariaControls = null,
  ariaExpanded = null,
}) {
  return (
    <div className={`hpsb ${column ? 'column' : ''} ${className ? className : ''} ${shorterOnMobile ? 'hpsb--shorter-on-mobile' : ''}`}>
      {/* <p className={`hpsb__lbl${shorten ? ' tp--ell' : ''} tp-w--s c-txt--w`}> */}
      <p className={`hpsb__lbl${isLocality ? ' tp--ell' : ''} tp-w--s c-txt--w`}>
        {label}
      </p>
      <div className={notClickable ? 'is-rel' : 'hpsb__und'}>
        <Grid
          className={`hpsb__btn tp-w--l tp--ell c-txt--w${smaller ? ' hpsb__btn--smaller' : ''} ${notClickable ? '' : 'is-clickable'}`}
          noWrap
          role="button"
          tabIndex={notClickable ? null : 0}
          onClick={onClickAction}
          onKeyPress={onKeyPressAction}
          aria-label={ariaLabel}
          aria-description={ariaDescription}
          aria-haspopup={ariaHaspopup}
          aria-controls={ariaControls}
          aria-expanded={ariaExpanded}
        >
          <GridItem className={isPlaceholder ? 'hpsb__btn--placeholder' : 'tp--ell'}>{button}</GridItem>
          {more && (
            <GridItem behavior="fixed">
              {more}
            </GridItem>
          )}
          {icon && (
            <GridItem behavior="fixed">
              {icon}
            </GridItem>
          )}
        </Grid>
      </div>
    </div>
  );
}